import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';
import ReactPlaceholder from 'react-placeholder';
import 'react-placeholder/lib/reactPlaceholder.css';

const funErrorMessages = [
  'O No!!, I broke myself.',
  'Oops, I did it again.',
  'I am not a robot, but I made a mistake.',
  'I am sorry, I am just a machine.',
]

const peterMessages = [
  'Yell at Peter for breaking me',
  'Tell Peter to fix me',
  'Peter is the reason for all your problems',
]

const randomMessage = (array: string[]) => {
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
}

const randomFunErrorMessage = () => {
  return randomMessage(funErrorMessages) + '  ' + randomMessage(peterMessages) + ' but try refreshing the page first.';
}

const asyncComponent = (importComponent: () => Promise<any>) => {
  const AsyncFunc = (props: any) => {
    const [Component, setComponent] = useState<ReactNode | null>(null);

    useEffect(() => {
      Nprogress.start();
      //return () => Nprogress.stop();
    }, []);

    useEffect(() => {
      console.log('running async effect');
      const doMount = async () => {
        const { default: Component } = await importComponent();
        if (!Component) {
          const test = await importComponent();
          console.log('Bad component import', test);
        }
        console.log('component', Component);
        Nprogress.done();
        setComponent(<Component {...props} />);
      };

      doMount().catch((e) => {
        console.log('error mounting', e);
        Nprogress.done();
        console.log('reloading page');
        // window.location.reload();
        setComponent(
          <div>
            <div>{randomFunErrorMessage()}</div>
            <div>{e.toString()}</div>
            <button
              style={{
                backgroundColor: '#008CBA',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div>
        );
      });

      return () => {
        setComponent(null);
      };
    }, [props]);

    return (
      <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
        {Component ?? <div />}
      </ReactPlaceholder>
    );
  };

  return AsyncFunc;
};

const asyncNamedComponent = (importComponent: () => Promise<any>) => {
  const AsyncNamedFunc: React.FC<any> = (props) => {
    const [Component, setComponent] = useState<ReactNode | null>(null);

    useEffect(() => {
      Nprogress.start();
      //return () => Nprogress.stop();
    }, []);

    useEffect(() => {
      const doMount = async () => {
        const Component = await importComponent();
        Nprogress.done();
        setComponent(<Component {...props} />);
      };

      doMount().catch((e) => {
        console.log('error mounting', e);
        Nprogress.done();
        console.log('reloading page async');
        // window.location.reload();
        setComponent(
          <div>
            <div>{randomFunErrorMessage()}</div>
            <div>{e.toString()}</div>
            <button
              style={{
                backgroundColor: '#008CBA',
                color: 'white',
                padding: '12px 24px',
                border: 'none',
                borderRadius: '20px',
                cursor: 'pointer',
              }}
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
          </div >
        );
      });

      return () => {
        setComponent(null);
      };
    }, [props]);

    return (
      <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
        {Component ?? <div />}
      </ReactPlaceholder>
    );
  };

  return AsyncNamedFunc;
};

export { asyncComponent, asyncNamedComponent };

